import React from 'react';
import { Link } from 'gatsby';
import * as styles from './NavigationButton.module.css';

interface NavigationButtonProps {
  to: string;
  label: string;
  className?: string;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({
  to,
  label,
  className,
}) => {
  return (
    <Link to={to} className={`${styles.navButton} ${className || ''}`}>
      <div className={styles.buttonContent}>
        <div className={styles.buttonText}>
          {label}
        </div>
      </div>
    </Link>
  );
};

export default NavigationButton;
